const getters = {
  sidebar: state => state.app.sidebar,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  userdata: state => state.user.userdata,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  dictdata: state => state.dict.dictdata,
  unReadCount: state => state.user.unReadCount,
  downAction: state => state.app.downAction,
  webInfo: state => state.app.webInfo,
  homeColumns: state => state.app.homeColumns
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js